import {  MouseEvent } from 'react';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';

type IQuickViewProps = {
    variantId: string;
    onQuickView: (variantId: string) => void;
};

export const QuickView: Globals.FC<IQuickViewProps> = props => {
    const { variantId, onQuickView } = props;
    const { t } = useTrans();

    const handleClick = (e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onQuickView(variantId);
    }

    return (
        <button
            type={'button'}
            className={'g-quick-view'}
            onClick={e => handleClick(e)}
        >
            <Iconfont className={'icon-eye'}/> <span>{t('web_common_btn_quick_view')}</span>
        </button>
    )
};